<template>
  <div class="page" @keyup.delete="deleteKeyup()">
    <div class="main">
      <div class="login">验证码</div>
      <div class="login-text">验证码已发送至{{ userPhone }}，请输入4位数字验证码</div>
      <div class="captcha">
        <input
          v-for="(c, index) in ct"
          :key="index"
          ref="input"
          v-model="ct[index]"
          type="number"
          :style="{borderBottomColor: index <= cIndex ? '#00c777' : ''}"
          :disabled="loading"
          @input="e => {onInput(e.target.value, index)}"
          @keydown.delete="e=>{onKeydown(e.target.value, index)}"
          @focus="onFocus"
        >
      </div>
      <div class="point">没有收到验证码？
        <template v-if="!countdown">已发送({{ count }})</template>
        <span v-if="countdown" class="once" @click="onSubmit">再次发送</span>
      </div>
      <van-button class="bu_tn-a" round block type="info" native-type="submit" @click="loginSumbit">登录</van-button>
    </div>
  </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast } from 'vant'
export default {
  data() {
    return {
      userPhone: localStorage.getItem('userPhone'),
      isLogin: true,
      checked: true,
      countdown: false,
      timer: null,
      count: null,
      ct: ['', '', '', ''],
      loading: false
    }
  },
  computed: {
    ctSize() {
      return this.ct.length
    },
    cIndex() {
      let i = this.ct.findIndex(item => item === '')
      i = (i + this.ctSize) % this.ctSize
      return i
    },
    lastCode() {
      return this.ct[this.ctSize - 1]
    }
  },
  watch: {
    cIndex() {
      this.resetCaret()
    },
    lastCode(val) {
      if (val) {
        this.$refs.input[this.ctSize - 1].blur()
      }
    }
  },
  mounted() {
    this.countDown()
    this.resetCaret()
    document.onkeydown = (e) => {
      if (e.keyCode == 8) { // 这是delete健，当然也可以根据自己的需求更改
        this.deleteKeyup()// 操作方法
      }
    }
  },
  methods: {
    onSubmit() {
      if (!(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.userPhone))) {
        Toast.fail('请填写正确的手机号')
        return
      }
      wxRequest('/bindPhone/sms/code', { userPhone: this.userPhone }, 'post').then(res => {
        if (res.data.code == 200) {
          this.countDown()
        } else {
          Toast.fail(res.data.message)
        }
      })
    },

    loginSumbit() {
      var params = {
        iccid: localStorage.getItem('iccid'),
        userPhone: this.userPhone,
        smsCode: String(this.ct.join(''))
      }
      wxRequest('/bindPhone/phone/new', params, 'post').then(res => {
        if (res.data.code === '200') {
          this.$router.replace('/newUser/home')
        } else {
          Toast.fail(res.data.message)
        }
      })
    },
    countDown() {
      const TIME_COUNT = 59
      if (!this.timer) {
        this.count = TIME_COUNT
        this.countdown = false
        this.timer = setInterval(() => {
          if (this.count > 0) {
            this.count--
          } else {
            this.countdown = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
    onInput(val, index) {
      val = val.replace(/\s/g, '')
      if (index === this.ctSize - 1) {
        this.ct[this.ctSize - 1] = val[0] // 最后一个码，只允许输入一个字符。
      } else if (val.length > 1) {
        let i = index
        for (i = index; i < this.ctSize && i - index < val.length; i++) {
          this.ct[i] = val[i]
        }
        this.resetCaret()
      }
    },
    // 重置光标位置。
    resetCaret() {
      this.$refs.input[this.ctSize - 1].focus()
    },
    onFocus() {
      // 监听 focus 事件，将光标重定位到“第一个空白符的位置”。
      let index = this.ct.findIndex(item => item === '')
      index = (index + this.ctSize) % this.ctSize
      this.$refs.input[index].focus()
    },
    onKeydown(val, index) {
      if (val === '') {
        // 删除上一个input里的值，并对其focus。
        if (index > 0) {
          this.ct[index - 1] = ''
          this.$refs.input[index - 1].focus()
        }
      }
    },
    deleteKeyup() {
      this.$refs.input[this.ctSize - 1].focus()
    },
    sendCaptcha() {
      // 此时无法操作 input。。
      this.loading = true
      setTimeout(() => {
        this.loading = false
        this.$nextTick(() => {
          this.reset()
        })
      }, 3000)
    },

    reset() {
      // 重置。一般是验证码错误时触发。
      this.ct = this.ct.map(item => '')
      this.resetCaret()
    }
  }
}
</script>
<style lang="less" scoped>
.page{
    background: #f7f8fa;
    display: flex;
    flex-direction: column;
    flex: 1;
    height:100%;
    .main{
        flex: 1;
        display: flex;
        align-items: stretch;
        flex-direction: column;
        .login{
            margin: 60px 0px 0px 24px;
            font-size: 28px;
            color: rgb(6, 18, 30);
            font-weight: bold;
        }
        .login-text{
            color: #707070;
            font-size: 16px;
            margin-left:24px;
            margin-top: 14px;
            line-height:20px;
            width:90%;
        }
        .captcha {
            display: flex;
            justify-content: center;
            margin-top: 40px;
        }
        input {
            margin-right: 20px;
            width: 45px;
            text-align: center;
            border: none;
            border-bottom: 1px solid #212121;
            font-size: 24px;
            outline: none;
            background: none;
        }
        input:last-of-type {
            margin-right: 0;
        }
        input:disabled {
            color: #000;
            background-color: #fff;
        }
        .point{
            flex-direction: row;
            margin-top: 37px;
            justify-content: center;
            display: flex;
            font-size: 17px;
            color: #707070;
            margin-bottom: 36px;
            .once{
                color:#0c62ee;
            }
        }

        .ph-input{
            margin: 40px 24px 20px;
            height: 60px;
            border-bottom: 1px solid #06121e;
            flex-direction: row;
            align-items: center;
            flex-grow: 0;
            display: flex;
            .ph-text{
                color: #06121e;
                width: 50px;
                line-height: 50px;
                height: 50px;
                font-size: 17px;
            }
            .ph-t{
                color: #06121e;
                flex: 1;
                line-height: 50px;
                height: 50px;
                font-size: 17px;
                padding: 0;
                background: none;
                ::v-deep.van-cell__value{
                    .van-field__control{
                        background: none;
                    }
                }
            }
        }
        .bu_tn{
            width: 230px;
            height: 50px;
            line-height: 50px;
            background: rgba(52,118,254,.1)!important;
            color: #3476fe;
            border: 0!important;
            border-radius: 94px;
            font-size: 16px;
            align-self: center;
            text-align: center;
        }
        .bu_tn-a{
            width: 230px;
            height: 50px;
            line-height: 50px;
            background: #3476fe!important;
            color: #fff;
            border: 0!important;
            border-radius: 94px;
            font-size: 16px;
            align-self: center;
            text-align: center;
        }
    }
    .agree{
        display: flex;
        width:300px;
        position:fixed;
        bottom:25px;
        flex-direction: row;
        justify-content: center;
        margin: auto;
        left:0;
        right: 0;
        text-align: center;
        line-height:20px;
        .van-checkbox{
            margin-right: 6px;
            width: 30px;
            ::v-deep .van-icon{
                width: 1em;
                height: 1em;
                line-height: 1;
            }
        }
        span{
            color:#0c62ee;
            display: contents;
        }
    }
}
</style>
